const investmentFundAssetsLang = {
	multiple_title: {
		tag: 'investment.fund_assets.multiple_title',
		fr: 'Multiple',
		en: 'Multiple',
	},
	multiple_tooltip: {
		tag: 'investment.fund_assets.multiple_tooltip',
		fr: "= (Distribution + FMV) / Capital investi dans l'actif",
		en: '= (Distribution + FMV) / Asset contributed capital',
	},
	investment_at_title: {
		tag: 'investment.fund_assets.investment_at_title',
		fr: 'Investissement le',
		en: 'Investment at',
	},
	reporting_of_title: {
		tag: 'investment.fund_assets.reporting_of_title',
		fr: 'Reporting',
		en: 'Reporting',
	},
	percent_of_asset_owned: {
		tag: 'investment.fund_assets.percent_of_asset_owned',
		fr: "Emprise du fonds sur l'actif",
		en: '% of asset owned by the fund',
	},
	contributed_capital: {
		tag: 'investment.fund_assets.contributed_capital',
		fr: 'Montant investit par le fonds',
		en: 'Contributed capital',
	},
	fmv: {
		tag: 'investment.fund_assets.fmv',
		fr: 'FMV',
		en: 'FMV',
	},
	distribution: {
		tag: 'investment.fund_assets.distribution',
		fr: 'Distribution',
		en: 'Distribution',
	},
	status: {
		tag: 'investment.fund_assets.status',
		fr: 'Statut',
		en: 'Status',
	},
	reporting_status_realized: {
		tag: 'investment.fund_assets.reporting_status_realized',
		fr: 'Réalisé',
		en: 'Exit',
	},
	reporting_status_unrealized: {
		tag: 'investment.fund_assets.reporting_status_unrealized',
		fr: 'Actif',
		en: 'Active',
	},
	reporting_status_partial: {
		tag: 'investment.fund_assets.reporting_status_partial',
		fr: 'Partiellement réalisé',
		en: 'Partial exit',
	},
	no_quarterly_report_available: {
		tag: 'investment.fund_assets.no_quarterly_report_available',
		fr: 'Aucun rapport trimestriel disponible',
		en: 'No quarterly report available',
	},
};

export default investmentFundAssetsLang;
